
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".344","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M10.006 14.062c-.97 0-1.801-.206-2.492-.617a4.09 4.09 0 01-1.596-1.75c-.364-.755-.546-1.656-.546-2.702 0-1.036.182-1.932.546-2.688a4.09 4.09 0 011.596-1.75c.69-.41 1.521-.616 2.492-.616.579 0 1.13.084 1.652.252.523.168.975.406 1.358.714.159.112.247.243.266.392a.554.554 0 01-.07.406.538.538 0 01-.322.224c-.13.028-.28-.018-.448-.14-.663-.532-1.465-.798-2.408-.798-1.11 0-1.96.35-2.548 1.05-.588.7-.882 1.685-.882 2.954 0 1.28.294 2.268.882 2.968.588.7 1.437 1.05 2.548 1.05.943 0 1.755-.27 2.436-.811.168-.112.317-.154.448-.127.14.028.243.098.308.21a.532.532 0 01.084.379c-.019.14-.098.265-.238.377a4.277 4.277 0 01-1.386.77 5.458 5.458 0 01-1.68.253z","fill":"#000"}})])
          )
        }
      }
    